<template>
  <div class="about-container">
    <div class="content-box">
      <div class="content-box-top-banner">
        <div class="text-block">
          <div class="text-block-title page-carousel-title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">
            洞悉数据之美 <div>感知精彩世界
            </div>
          </div>
          <div class="text-block-desc page-carousel-desc  wow fadeInUp" data-wow-delay="0.5s">专注于无人机领域 提供人工智能服务</div>
        </div>
      </div>
      <div class="tab-bar">
        <div class="tab-box">
          <div class="tab-item" @click="goPage('/about/company-profile')" :class="{ 'active': profileActive }"
            @mouseover="toggleState('profile', true)" @mouseout="toggleState('profile', false)">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/aboute_icon_profile_active.png"
              alt="" v-if="profileActive" />
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/aboute_icon_profile.png"
              alt="" v-else />
            <div>焱图简介</div>
          </div>
          <div class="tab-item" @click="goPage('/about/company-news')" :class="{ 'active': newsActive }"
            @mouseover="toggleState('news', true)" @mouseout="toggleState('news', false)">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/about_icon_news.png"
              v-if="!newsActive" alt="" />
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/about_icon_news_active.png"
              v-else alt="" />
            <div>焱图动态</div>
          </div>
          <div class="tab-item" @click="goPage('/about/company-honors')" :class="{ 'active': honorsActive }"
            @mouseover="toggleState('honors', true)" @mouseout="toggleState('honors', false)">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/about_icon_honors.png"
              v-if="!honorsActive" alt="" />
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/about_icon_honors_active.png"
              v-else alt="" />
            <div>荣誉资质</div>
          </div>
          <div class="tab-item" @click="goPage('/about/company-address')" :class="{ 'active': phoneActive }"
            @mouseover="toggleState('address', true)" @mouseout="toggleState('address', false)">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/aboute_icon_prophone.png"
              v-if="!phoneActive" alt="" />
            <img v-else
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/aboute_icon_prophone_active.png"
              alt="" />
            <div>联系我们</div>
          </div>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {
      profileActive: false,
      newsActive: false,
      honorsActive: false,
      phoneActive: false,
      activePath: "",
      textObj: {}
    };
  },
  mounted() {
    console.log(789789)
    this.activePath = this.$route.path;
    this.bannerClass()
  },
  watch: {
    $route(to, from) {
      // 在这里检查路由的变化并执行相应的操作
      if (to.path !== from.path) {
        this.activePath = to.path
        this.bannerClass()
        this.$nextTick(() => {
          new WOW().init();
        });
      }
    }
  },
  beforeDestroy() {
    this.activePath = ""
  },

  // created() {
  //   this.activePath = this.$route.path;
  //   this.bannerClass()
  //   console.log(this.activePath,88888)
  // },

  methods: {
    bannerClass() {
      if (this.$route.path.includes('company-profile')) {
        this.profileActive = true
        this.newsActive = false
        this.honorsActive = false
        this.phoneActive = false
        return 'company-profile-banner';
      }
      else if (this.activePath.includes('company-news')) {
        this.newsActive = true
        this.profileActive = false
        this.honorsActive = false
        this.phoneActive = false
        return 'company-news-banner';
      } else if (this.activePath.includes('company-honors')) {
        this.honorsActive = true
        this.newsActive = false
        this.profileActive = false
        this.phoneActive = false
        return 'company-honors-banner';
      } else {
        this.phoneActive = true
        this.honorsActive = false
        this.newsActive = false
        this.profileActive = false
        return 'contact-banner';
      }
    },
    goPage(path) {
      if (this.activePath != path) {
        this.activePath = path
        this.bannerClass()
        this.$router.push(path)
      }
    },
    toggleState(target, value) {
      // 简介  当前tab不是当前页面的时候鼠进入和离开才展示的效果
      if (target == 'profile') {
        if (this.$route.path.indexOf('company-profile') == '-1') {
          this.profileActive = value
        }
        return
      }

      if (target == 'news') {
        if (this.$route.path.indexOf('company-news') == '-1') {
          this.newsActive = value
        }
        return
      }

      if (target == 'honors') {
        if (this.$route.path.indexOf('company-honors') == '-1') {
          this.honorsActive = value
        }
        return
      }

      if (target == 'address') {
        if (this.$route.path.indexOf('company-address') == '-1') {
          this.phoneActive = value
        }
        return
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.about-container {
  width:100%;
  height:100%;
 .content-box {
    // background-color: #F6F7F9;
    .company-profile-banner {
        background-size:cover;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/company_profile_banner.png");
    }
    .company-news-banner {
        background-size:cover;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/company_news_banner.png") !important;
    }
    .company-honors-banner {
        background-size:cover;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/company_honors_banner.png");
    }
    .contact-banner {
        background-size:cover;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/contact_us_banner.png");
    }
    .content-box-top-banner {
      height:27.75rem;
      background-size:cover;
      background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/banner4.png");
      margin-top:4.18rem;
      width:100%;
      display:flex;
      align-items:center;
      background-repeat:no-repeat;
      position:relative;
      .text-block {
        color:#fff;
        position:absolute;
        top:10.812rem;
        left:16.375rem;
        .text-block-title {
          letter-spacing:2px;
          display:flex;
          margin-bottom:1.25rem;
          div {
            margin-left:2rem;
          }
        }
        .text-block-desc {
          letter-spacing:2px;
        }
      }
    }
    .tab-bar {
      background: #10151B;
      width:100%;
      .tab-box {
        display:flex;
        max-width:var(--main-width);
        width:84%;
        margin:0 auto;
        font-size:1.1rem;

        .active {
          background: rgba(255,255,255,0.15);
        }
        .tab-item {
          padding:1rem 0 1.18rem 0.81rem;
          color:#FFFFFF;
          width:10.625rem;
          cursor:pointer;
          img {
            transition: transform 0.5s ease;
            ransform-style: preserve-3d;
          }
          
        }
        .tab-item:hover {
          background: rgba(255, 255, 255, 0.15);
          img {
            transform: rotateY(360deg);
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
}
@media only screen and (max-width: 768px) {

  .content-box-top-banner {
    height:220px !important;
    .text-block {
      left:26px !important;
      top:85px !important;
    }
    .text-block-title {
      font-size:24px !important;
      display:block !important;
      div {
        margin-left:0px !important;
      }
    }
    .text-block-desc {
      font-size:14px !important;
    }
  
  }
  .company-honors-banner {
        height:229px;
        background-size:cover !important;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/mobile/about_mobile_banner.png") !important;
    }
    .contact-banner {
      background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/mobile/address_mobile_banner.png") !important;
    }
    .tab-box {
      width:auto !important;
      font-size:14px !important;
    }
}
</style>
